import { FileLoader } from "ckeditor5";
import typography from "constants/typography.constants";

const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
export default class UploadAdapter {
  constructor(
    private loader: FileLoader,
    private readonly handleUploadFile: (file: File) => Promise<{
      default: string;
    }>,
    private readonly onError: (text: string) => void
  ) {
    this.loader = loader;
    this.handleUploadFile = handleUploadFile;
    this.onError = onError;
  }

  async upload(): Promise<{ default: string }> {
    return this.loader.file.then((file) => {
      if (!file) {
        const message = typography.errors.pleaseRepeat;
        this.onError(message);
        return Promise.reject(message);
      }

      if (file.size > MAX_IMAGE_SIZE) {
        const message = `Размер файла превышает ${MAX_IMAGE_SIZE / (1024 * 1024)}MB`;
        this.onError(message);
        return Promise.reject(message);
      }

      const data = new FormData();
      data.append("file", file);

      return this.handleUploadFile(file);
    });
  }
}
